import { Logger } from '@eluve/logger';

/**
 * @deprecated Use `useNamedLogger` or `useExtendedLogger` from `@eluve/logger` instead.
 */
export const logger = new Logger('eluve-web');
